<template>
    <div class="dashboard-admin-page">
        <div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="title-button">
                            <h2>Dashboard</h2>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-8">
                        <div class="welcome radius-6">
                            <div class="content">
                                <h4 class="title">Bem vindo (a)</h4>
                                <div class="font-14 text">
                                    Como Administrador da plataforma, você tem acesso para visualizar, editar e demais
                                    configurações da plataforma
                                </div>

                                <img
                                    :src="require(`@/assets/undraw_dashboard_nklg_2.svg`)"
                                    alt="undraw_dashboard_nklg_2"
                                />
                            </div>
                        </div>

                        <div class="profiles">
                            <h6>Perfis da plataforma</h6>
                            <div class="font-14 text">Clique em um dos cards para acessar.</div>

                            <div class="cards">
                                <div class="card radius-6" v-for="(item, index) in Object.keys(profiles)" :key="index">
                                    <div class="content">
                                        <h5 class="quantity">{{ profiles[item].value }}</h5>
                                        <div>{{ profiles[item].name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="profiles-chart">
                            <h6>Gráficos</h6>
                            <div class="font-14 text">Clique em um dos perfis para visualizar a evolução.</div>

                            <Chart
                                :id="chart.idChart"
                                :idChart="chart.idChart"
                                :type="'line'"
                                :labels="chart.labels"
                                :datasets="chart.datasets"
                            />
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="quick-access">
                            <h6>Acesso rápido</h6>
                            <div class="font-14">Clique em um dos cards para acessar.</div>

                            <div class="cards">
                                <div class="card radius-6">
                                    <div class="image">
                                        <img :src="require(`@/assets/people.svg`)" alt="people" />
                                    </div>

                                    <h5 class="quantity">{{ connectionsNumber }}</h5>

                                    <div>Conexões</div>
                                </div>

                                <div class="card radius-6">
                                    <div class="image">
                                        <StarsPP :starsFullNumber="starsNumbers" />
                                    </div>

                                    <h5 class="quantity">{{ evaluationsNumber }}</h5>

                                    <div>Avaliações</div>
                                </div>
                            </div>
                        </div>

                        <div class="activities">
                            <h6>Atividades recentes</h6>
                            <div class="texts display-flex">
                                <div class="text font-14">Atualizações</div>
                                <router-link class="text font-14" :to="{ name: 'InitiativesAdminPage' }">
                                    Ver todas
                                </router-link>
                            </div>

                            <div class="cards">
                                <div class="card radius-6" v-for="(item, index) in activities" :key="index">
                                    <div class="card-icon">
                                        <img :src="activityIcons[item.type]" alt="Icon_activity_register" />
                                    </div>

                                    <div class="card-content font-14">
                                        <div class="display-flex content">
                                            <div class="title">{{ item.title }}</div>
                                            <div class="date">{{ item.date }}</div>
                                        </div>

                                        <div v-html="item.text"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="cards-filter" v-if="false">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 card-col" v-for="(card, $index) in cardsFilter" :key="$index">
                        <div class="card radius-6">
                            <h5>{{ card.title }}</h5>
                            <div class="msg">{{ card.msg }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="connection-suggestions radius-6">
                <div class="title-button">
                    <h6>Sugestões de Conexão</h6>

                    <b-button variant="primary" size="sm" class="mb-2 icon-button">
                        <b-icon icon="download" aria-hidden="true"></b-icon> Exportar
                    </b-button>
                </div>
            </div>
        </div> -->

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import StarsPP from '@/ui/stars-pp/StarsPP'
import Chart from '@/ui/chart/Chart'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { DashboardAdminApi } from '../../../../api/dashboard-admin-api'

const dashboardAdminApi = new DashboardAdminApi()

export default {
    components: { StarsPP, Chart, DangerModalPP },
    data() {
        return {
            message: null,
            starsNumbers: 0,
            connectionsNumber: 0,
            evaluationsNumber: 0,
            profiles: {
                investors: {
                    name: 'Investidores cadastrados',
                    value: 0
                },
                initiatives: {
                    name: 'Iniciativas cadastradas',
                    value: 0
                },
                serviceProvision: {
                    name: 'Prestadores de serviço cadastrados',
                    value: 0
                }
            },
            activityIcons: {
                register: require(`@/assets/Icon_activity_register.svg`),
                exclusion: require(`@/assets/Icon_activity_exclusion.svg`),
                message: require(`@/assets/Icon_activity_message.svg`)
            },
            activities: [
                {
                    type: 'register',
                    date: '22/02/2020',
                    title: 'Cadastro',
                    text: 'Um novo investidor iniciou o cadastro na plataforma.'
                }
            ],
            chart: {
                idChart: 'chart-left',
                labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                datasets: [
                    {
                        label: 'Investidores',
                        data: [75, 110, 130, 110, 110, 120, 140, 120, 10, 50, 30, 70],
                        backgroundColor: 'rgba(34, 184, 207, 0.1)',
                        borderColor: '#22B8CF',
                        borderWidth: 2
                    },
                    {
                        label: 'Iniciativas',
                        data: [85, 140, 130, 140, 120, 130, 150, 130, 20, 60, 40, 80],
                        backgroundColor: 'rgba(240, 101, 149, 0.1)',
                        borderColor: '#F06595',
                        borderWidth: 2
                    },
                    {
                        label: 'Prestadores de Serviço',
                        data: [95, 130, 150, 160, 140, 150, 170, 150, 30, 70, 50, 90],
                        backgroundColor: 'rgba(252, 196, 25, 0.1)',
                        borderColor: '#FCC419',
                        borderWidth: 2
                    }
                ]
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading']),
        fetch() {
            this.setIsLoading(true)

            dashboardAdminApi
                .getDashboardAdmin()
                .then(response => {
                    const data = response.data.data
                    this.activities = data.atividades_recente.map(item => ({
                        type: 'register',
                        date: this.getDateFormat(item.created_at.replace('Z', '-03:00')),
                        title: 'Cadastro',
                        text: `Uma nova organização <b>(${item.nome_organizacao})</b> iniciou o cadastro na plataforma.`
                    }))

                    this.evaluationsNumber = data.totalAvaliacao
                    this.connectionsNumber = data.conexao
                    this.starsNumbers = data.estrela
                    this.profiles.investors.value = data.organizacao.investidor.length
                    this.profiles.initiatives.value = data.organizacao.iniciativa.length
                    this.profiles.serviceProvision.value = data.organizacao.prestador_servico.length
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        getDateFormat(dateText) {
            const date = new Date(dateText)
            return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        }
    },
    created() {
        this.fetch()
    }
}
</script>

<style scope src="./DashboardAdminPage-light-theme.css"></style>
<style scope src="./DashboardAdminPage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-admin-grid-page/dashboard-admin-page/DashboardAdminPage.vue